<template>
  <div class="monitor-tasks-page" style="height: calc(100vh - 135px); overflow: auto; padding-right: 8px;">
    <div class="page-header-row">
      <div class="page-title-wrap">
        <span class="page_title">监控任务配置</span>
        <span class="page_subtitle">将线路与车辆、时间段、告警策略绑定，形成可运行的偏离检测任务</span>
      </div>
      <div class="header-actions">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreateDialog">
          新建任务
        </el-button>
      </div>
    </div>

    <el-card class="list-card" shadow="never">
      <div slot="header" class="card-header">
        <div class="search-bar">
          <el-input size="small" v-model="searchForm.keyword" placeholder="搜索任务名 / 线路 / 车辆车牌" clearable
            style="width: 320px;" @clear="handleSearch" @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>

          <el-select v-model="searchForm.status" size="small" placeholder="状态" clearable
            style="width: 130px; margin-left: 10px;" @change="handleSearch">
            <el-option label="启用中" :value="1" />
            <el-option label="已停用" :value="0" />
          </el-select>

          <el-select v-model="searchForm.routeId" size="small" placeholder="按线路筛选" clearable filterable
            style="width: 220px; margin-left: 10px;" @change="handleSearch">
            <el-option v-for="r in routeOptions" :key="r.id" :label="r.name" :value="r.id" />
          </el-select>

          <el-button size="small" icon="el-icon-refresh" @click="handleSearch" style="margin-left: 10px;">刷新</el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="listData" style="width: 100%;" :max-height="'calc(100vh - 280px)'" border
        highlight-current-row @row-dblclick="openEditDialog">
        <el-table-column type="index" label="#" width="50" align="center" />
        <el-table-column prop="name" label="任务名称" min-width="200" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span style="font-weight: 500;">{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="routeName" label="关联线路" min-width="180" show-overflow-tooltip />
        <el-table-column label="车辆数" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="warning">{{ row.vehicleCount }}</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="阈值" width="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.thresholdM }}m / 恢复{{ row.recoverThresholdM }}m</span>
          </template>
        </el-table-column> -->
        <el-table-column label="时间范围" min-width="240">
          <template slot-scope="{ row }">
            <div class="time-col">
              <div class="time-main">
                <i class="el-icon-date" style="color:#909399; margin-right:4px;"></i>
                {{ row.validFrom }} ~ {{ row.validTo }}
              </div>
              <div class="time-sub">
                <span v-if="row.weekdaysText || row.dailySlotsText">{{ row.weekdaysText }} · {{ row.dailySlotsText
                  }}</span>
                <span v-else class="once-tag">单次任务，全程生效</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="告警级别" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="alarmLevelTag(row.alarmLevel)">{{ row.alarmLevelText }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="statusText" label="状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.status === 1 ? 'success' : 'info'">{{ row.statusText }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" label="更新时间" width="160" align="center" />
        <el-table-column label="操作" width="260" fixed="right" align="center">
          <template slot-scope="{ row }">
            
            <el-button size="mini" type="text" @click="openEditDialog(row)">编辑</el-button>
         
            <el-button size="mini" type="text" style="color: #F56C6C;" @click="confirmDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <kl-pagination :total="total" :page-size="pageSize" :current-page.sync="currentPage"
          @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </el-card>

    <BindingFormDialog :visible.sync="formDialogVisible" :binding-id="currentBindingId" @saved="onSaved" />

    <el-drawer title="任务详情" :visible.sync="detailVisible" size="760px" direction="rtl" class="binding-detail-drawer">
      <div v-if="currentDetail" class="detail-content" v-loading="detailLoading">
        <el-descriptions title="基础信息" :column="1" border size="small">
          <el-descriptions-item label="任务名称">{{ currentDetail.name }}</el-descriptions-item>
          <el-descriptions-item label="关联线路">{{ currentDetail.routeName }} <span class="muted">#{{ currentDetail.routeId
              }}</span></el-descriptions-item>
          <el-descriptions-item label="车辆数">
            {{ currentDetail.vehicleCount }} 辆
            <el-tag size="mini" type="info" style="margin-left: 8px;">阈值 {{ currentDetail.thresholdM }}m</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="生效类型">{{ currentDetail.effectiveTypeText }}</el-descriptions-item>
          <el-descriptions-item label="有效期">{{ currentDetail.validFrom }} ~ {{ currentDetail.validTo
            }}</el-descriptions-item>
          <el-descriptions-item label="周期时间" v-if="currentDetail.effectiveType === 2">
            {{ currentDetail.weekdaysText }}<br />{{ currentDetail.dailySlotsText }}
          </el-descriptions-item>
          <el-descriptions-item label="告警级别">{{ currentDetail.alarmLevelText }}</el-descriptions-item>
          <el-descriptions-item label="通知渠道">{{ currentDetail.notifyChannelsText }}</el-descriptions-item>
          <el-descriptions-item label="接收人">{{ currentDetail.notifyReceiversText }}</el-descriptions-item>
          <el-descriptions-item label="静默期">{{ currentDetail.silenceMinutes }} 分钟</el-descriptions-item>
        </el-descriptions>

        <div class="detail-section">
          <div class="section-title"><i class="el-icon-map-location"></i> 关联线路地图
            <span class="meta-tags" style="float:right;">
              <el-tag size="mini" type="primary">长度 {{ currentDetail.routeDetail?.totalLengthKm || '—' }} km</el-tag>
              <el-tag size="mini" style="margin-left:4px;">共 {{ currentDetail.routeDetail?.pointCount || 0 }}
                个点</el-tag>
              <el-tag size="mini" type="warning" style="margin-left:4px;">阈值 {{ currentDetail.thresholdM }}m</el-tag>
            </span>
          </div>
          <div class="detail-map-wrap">
            <KingLongMap ref="taskDetailMap" :mapId="'taskDetailMap'" @LoadCompleted="onDetailMapLoaded" />
            <div class="detail-map-legend">
              <span class="lg-item"><span class="lg-line blue"></span>基准线</span>
              <span class="lg-item"><span class="lg-buf"></span>阈值圈</span>
              <span class="lg-item"><span class="lg-dot green"></span>起点</span>
              <span class="lg-item"><span class="lg-dot red"></span>终点</span>
              <span class="lg-item" v-if="(currentDetail.routeDetail?.extraPointCount || 0) > 0"><span
                  class="lg-dot orange"></span>豁免/途经</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title"><i class="el-icon-s-custom"></i> 绑定车辆列表（{{ currentDetail.vehicleCount }}）</div>
          <el-table :data="currentDetail.vehicles || []" size="small" border>
            <el-table-column prop="plateNo" label="车牌" width="130" />
            <el-table-column prop="driver" label="驾驶员" />
            <el-table-column prop="driverPhone" label="联系电话" />
          </el-table>
        </div>

        <div class="detail-section">
          <div class="section-title"><i class="el-icon-setting"></i> 偏离判定参数</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="触发阈值">{{ currentDetail.thresholdM }} m</el-descriptions-item>
            <el-descriptions-item label="恢复阈值">{{ currentDetail.recoverThresholdM }} m</el-descriptions-item>
            <el-descriptions-item label="连续点数">{{ currentDetail.triggerPointCount }} 点</el-descriptions-item>
            <el-descriptions-item label="持续时长">{{ currentDetail.triggerDurationS }} 秒</el-descriptions-item>
            <el-descriptions-item label="持续里程">{{ currentDetail.triggerDistanceM > 0 ? currentDetail.triggerDistanceM +
              ' m'
              : '不启用' }}</el-descriptions-item>
            <el-descriptions-item label="回归点数">{{ currentDetail.recoverPointCount }} 点</el-descriptions-item>
            <el-descriptions-item label="仅行驶中判定">{{ currentDetail.onlyWhenMoving ? '开启' : '关闭' }}</el-descriptions-item>
            <el-descriptions-item label="最小速度">{{ currentDetail.minSpeedKmh }} km/h</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  mockGetBindingDetail,
  mockToggleBindingStatus,
  mockGetRouteDetail
} from '../_mock/routeDeviationMock.js';
import BindingFormDialog from './components/BindingFormDialog.vue';
import KingLongMap from '@/components/KingLongMap.vue';

export default {
  name: 'MonitorTasks',
  components: { BindingFormDialog, KingLongMap },
  data() {
    return {
      loading: false,
      listData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: { keyword: '', status: null, routeId: null },
      routeOptions: [],
      formDialogVisible: false,
      currentBindingId: null,
      detailVisible: false,
      detailLoading: false,
      currentDetail: null,
      detailMapReady: false
    };
  },
  mounted() {
    this.loadList();
    this.loadRouteOptions();
  },
  methods: {
    alarmLevelTag(l) {
      return l === 3 ? 'danger' : l === 2 ? 'warning' : 'info';
    },
    loadRouteOptions() {
      // 按线路筛选数据源：真实接口查询有效线路
      this.$api.QueryPLRouteInfo({ QueryData: '', RouteStatus: 1, PageNo: 1, PageSize: 200 }).then(res => {
        if (res.code === 200) {
          this.routeOptions = (res.data || []).map(item => ({
            id: item.RouteID,
            name: item.RouteName
          }));
        }
      });
    },
    loadList() {
      this.loading = true;

      var TaskStatus = this.searchForm.status;
      if (TaskStatus === null || TaskStatus === '') TaskStatus = -1;

      this.$api.QueryMonitoringTask({
        QueryData: this.searchForm.keyword || '',       // 任务名/线路/车牌
        TaskStatus: TaskStatus,         // ''全部 1启用 0未启用
        RouteID: this.searchForm.routeId || 0,          // 0全部
        PageNo: this.currentPage,
        PageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.listData = (res.data || []).map(item => ({
            id: item.TaskID,
            name: item.TaskName,
            routeName: item.RouteName,
            vehicleCount: item.VehicleCount,
            effectiveType: item.EffMode,
            validFrom: (item.EffStartDate || '').split(' ')[0],
            validTo: (item.EffEndDate || '').split(' ')[0],
            weekdaysText: this.formatWeekdaysStr(item.WeekDays),
            dailySlotsText: item.Slots || '',
            status: item.TaskStatus,
            statusText: item.TaskStatus === 1 ? '启用中' : '已停用',
            updatedAt: item.UpdateTime
          }));
          this.total = res.recordsTotal || 0;
        }
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    formatWeekdaysStr(str) {
      if (!str) return '';
      const map = { 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '日' };
      return str.split(',').filter(Boolean).map(n => '周' + (map[n] || n)).join(',');
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadList();
    },
    handlePageChange(p) { this.currentPage = p; this.loadList(); },
    handleSizeChange(s) { this.pageSize = s; this.currentPage = 1; this.loadList(); },
    openCreateDialog() {
      this.currentBindingId = null;
      this.formDialogVisible = true;
    },
    openEditDialog(row) {
      this.currentBindingId = row ? row.id : null;
      this.formDialogVisible = true;
    },
    openDetail(row) {
      this.currentDetail = null;
      this.detailVisible = true;
      this.detailLoading = true;
      mockGetBindingDetail(row.id).then(res => {
        this.detailLoading = false;
        if (res.code === 200) {
          this.currentDetail = res.data;
          // 加载线路详情（含几何信息）
          mockGetRouteDetail(res.data.routeId).then(rr => {
            if (rr.code === 200) {
              this.$set(this.currentDetail, 'routeDetail', rr.data);
              this.$nextTick(() => this.drawDetailRoute());
            }
          });
          this.$nextTick(() => this.drawDetailRoute());
        }
      }).catch(() => { this.detailLoading = false; });
    },
    // ====== 任务详情地图 ======
    onDetailMapLoaded() {
      this.detailMapReady = true;
      this.$nextTick(() => this.drawDetailRoute());
    },
    drawDetailRoute() {
      const map = this.$refs.taskDetailMap;
      if (!map || !this.detailMapReady || !this.currentDetail?.routeDetail?.geom) return;
      map.clearAll();
      const rd = this.currentDetail.routeDetail;
      const th = this.currentDetail.thresholdM || 300;
      const coords = rd.geom.map(p => ({ lng: p[0], lat: p[1] }));
      // 阈值圈（关键节点）
      const step = Math.max(1, Math.floor(rd.geom.length / 12));
      for (let i = 0; i < rd.geom.length; i += step) {
        const [lng, lat] = rd.geom[i];
        map.addCircle('td_buf_' + i, { lng, lat }, th,
          1, 'rgba(64,158,255,0.3)', 'rgba(64,158,255,0.07)', false);
      }
      // 基准线
      map.addPolyline('td_route', rd.name || '线路', coords, 5, '#409EFF', true, true);
      // 起终点
      const start = rd.geom[0], end = rd.geom[rd.geom.length - 1];
      map.addMarker('td_start', '起点', start[0], start[1], null, null, 14, 14, { color: '#67C23A' });
      map.addMarker('td_end', '终点', end[0], end[1], null, null, 14, 14, { color: '#F56C6C' });
      // 附加点
      (rd.extraPoints || []).forEach((ep, i) => {
        if (ep.pointType === 2) {
          map.addCircle('td_epc_' + i, { lng: ep.lng, lat: ep.lat }, ep.radiusM || 200,
            2, '#E6A23C', 'rgba(230,162,60,0.12)', false);
          map.addMarker('td_ep_' + i, ep.name || '豁免点', ep.lng, ep.lat,
            null, null, 12, 12, { color: '#E6A23C' });
        } else {
          map.addMarker('td_ep_' + i, ep.name || '途经点', ep.lng, ep.lat,
            null, null, 12, 12, { color: '#909399' });
        }
      });
    },
    toggleStatus(row) {
      const target = row.status === 1 ? 0 : 1;
      const label = target === 1 ? '启用' : '停用';
      this.$confirm(`确定${label}任务「${row.name}」？`, `${label}确认`, {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        mockToggleBindingStatus(row.id, target).then(res => {
          if (res.code === 200) {
            this.$message.success(`已${label}`);
            this.loadList();
          }
        });
      }).catch(() => { });
    },
    confirmDelete(row) {
      this.$confirm(`确定删除任务「${row.name}」？该操作将解除所有车辆绑定，历史告警记录不会删除。`, '删除确认', {
        confirmButtonText: '删除', cancelButtonText: '取消', type: 'error'
      }).then(() => {
        this.$api.DelMonitoringTask({ TaskID: row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.loadList();
          }
        });
      }).catch(() => { });
    },
    onSaved() {
      this.formDialogVisible = false;
      this.loadList();
    }
  }
};
</script>

<style scoped>
.page-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 12px 0 16px;
}

.page-title-wrap {
  display: flex;
  align-items: baseline;
}

.page_title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.page_subtitle {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}

.header-actions {
  flex-shrink: 0;
}

.list-card {
  margin-bottom: 16px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.time-col {
  line-height: 1.4;
}

.time-main {
  font-size: 13px;
  color: #303133;
}

.time-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.once-tag {
  color: #409EFF;
}

.muted {
  color: #909399;
  font-size: 12px;
}

.pagination-wrap {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}

.detail-content {
  padding-right: 6px;
}

.detail-section {
  margin-top: 18px;
}

.section-title {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin: 0 0 10px;
  padding-bottom: 6px;
  border-bottom: 1px dashed #ebeef5;
  overflow: hidden;
}

.section-title i {
  color: #409EFF;
  margin-right: 4px;
}

.detail-map-wrap {
  position: relative;
  height: 340px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.detail-map-legend {
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: rgba(255, 255, 255, 0.96);
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 11px;
  color: #606266;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  z-index: 10;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.detail-map-legend .lg-item {
  display: inline-flex;
  align-items: center;
}

.detail-map-legend .lg-line {
  display: inline-block;
  width: 18px;
  height: 0;
  border-top: 3px solid;
  margin-right: 4px;
  border-radius: 2px;
}

.detail-map-legend .lg-line.blue {
  border-color: #409EFF;
}

.detail-map-legend .lg-buf {
  display: inline-block;
  width: 18px;
  height: 10px;
  background: rgba(64, 158, 255, 0.15);
  border: 1px solid rgba(64, 158, 255, 0.4);
  border-radius: 2px;
  margin-right: 4px;
}

.detail-map-legend .lg-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
  border: 1.5px solid #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
}

.detail-map-legend .lg-dot.green {
  background: #67C23A;
}

.detail-map-legend .lg-dot.red {
  background: #F56C6C;
}

.detail-map-legend .lg-dot.orange {
  background: #E6A23C;
}

.meta-tags .el-tag {
  vertical-align: middle;
}
</style>
